var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-title p-0"},[_c('div',{staticClass:"product-title-content"},[_c('img',{attrs:{"src":_vm.getIcon,"alt":"title"}}),_c('h2',{staticClass:"product-title-content__label"},[_vm._v(_vm._s(_vm.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }